import { IUser } from '../models/user';

export const author1: IUser = {
  id: 'f28afe15-ab01-4751-9d62-2c18509cf7d6',
  firstName: 'AM.Matthew',
  lastName: 'Lewis',
  email: 'lewis.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

export const author1Prod: IUser = {
  ...author1,
  id: '1dddb522-3a50-41d9-ba32-e02f1b893dc6'
};

export const author1PreProd: IUser = {
  ...author1,
  id: '1ba75147-6e70-43ee-88d6-ceee40ee016d'
};

export const author2: IUser = {
  id: '6f88ec42-eb69-4fff-abb7-5664b543f61d',
  firstName: 'AM.Wayne',
  lastName: 'Stark',
  email: 'stark.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

export const author2Prod: IUser = {
  ...author2,
  id: '72c163cd-f891-4f8f-83f6-ad5a0030b827'
};

export const author2PreProd: IUser = {
  ...author2,
  id: '8951e797-2e64-4d54-bffe-9725ad4bb4e7'
};

const editor1: IUser = {
  id: 'f848e7e5-ec82-4f9c-a8db-d923721c3f9c',
  firstName: 'EM.Rodger',
  lastName: 'Stancy',
  email: 'stancy.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

const editor2: IUser = {
  id: 'bb613087-a139-4382-b2fd-a486e104f1e4',
  firstName: 'EM.Amina',
  lastName: 'Patel',
  email: 'patel.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

const editor2Prod: IUser = {
  ...editor2,
  id: 'a1874e84-3a56-4c57-a2ed-a2f00663fcd7'
};

const editor2PreProd: IUser = {
  ...editor2,
  id: 'a770ad18-ce1a-4bf6-ab1d-542546243287'
};

export const editor1Prod: IUser = {
  ...editor1,
  id: '34480fd7-80df-43fd-867b-d31dc6e9ae2d'
};

export const editor1PreProd: IUser = {
  ...editor1,
  id: '5aa88df0-52dc-476c-94bc-43664fe319b5'
};

const reviewer1: IUser = {
  id: '3fa81184-f742-41c1-a5b5-e2633a495c23',
  firstName: 'RM.Teniola',
  lastName: 'Page',
  email: 'page.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

export const reviewer1Prod: IUser = {
  ...reviewer1,
  id: '9ff884a0-48ce-4462-992d-ff4fc04c38c2'
};

export const reviewer1PreProd: IUser = {
  ...reviewer1,
  id: '3344f296-569c-4785-847b-a396c8cb6e1e'
};

const reviewer2: IUser = {
  id: '5adf615c-87ee-4c68-a9d3-530f1f16b8a1',
  firstName: 'RM.John',
  lastName: 'Doe',
  email: 'doe.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

export const reviewer2Prod: IUser = {
  ...reviewer2,
  id: '2aa871d5-c60e-4613-aa5a-1c5d2d27562c'
};

export const reviewer2PreProd: IUser = {
  ...reviewer2,
  id: '7fda7315-a394-47fc-af80-734a8a359762'
};

const reviewer3: IUser = {
  id: 'cefd13c8-1caa-4c2f-a1e6-2bc5ccd267c8',
  firstName: 'RM.Monalisa',
  lastName: 'Paine',
  email: 'paine.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

export const reviewer3Prod: IUser = {
  ...reviewer3,
  id: '397ebfd9-90ce-4555-8b99-adf4e2ff6b53'
};

export const reviewer3PreProd: IUser = {
  ...reviewer3,
  id: 'bf3d4c79-c1a3-401a-b7b6-deaf1bfa5863'
};

const orgAdmin1: IUser = {
  id: '0ab9cc37-a0b1-4d53-acfc-624d33aeedb8',
  firstName: 'OM.Oscar',
  lastName: 'Odin',
  email: 'odin.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

export const orgAdmin1Prod: IUser = {
  ...orgAdmin1,
  id: '7aff7ca1-8de3-483c-932e-55e18ba918cb'
};

export const orgAdmin1PreProd: IUser = {
  ...orgAdmin1,
  id: 'ff789fef-6a47-432a-b638-3b6224851ea0'
};

const sysAdmin1: IUser = {
  id: 'b8e10ace-3252-465d-bda6-d0221a4516a0',
  firstName: 'SudoM',
  lastName: 'User',
  email: 'sudo.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

export const sysAdmin1Prod: IUser = {
  ...sysAdmin1,
  id: '1fe76d9d-4a9d-4d77-a2db-1b602355b895'
};

export const sysAdmin1PreProd: IUser = {
  ...sysAdmin1,
  id: 'f94c0c87-51e9-4208-be14-4820699b7784'
};

const boardMember1: IUser = {
  id: '325bfcc6-8878-450f-a259-5409c5114985',
  firstName: 'BM.Benjamin',
  lastName: 'Clark',
  email: 'bclark.board.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

const boardMember1Prod: IUser = {
  ...boardMember1,
  id: 'fb30eef9-63dc-443a-8758-38fb64a906aa'
};

const boardMember1PreProd: IUser = {
  ...boardMember1,
  id: 'ca3216ae-e4d4-49b8-9e88-bc5e57df9036'
};

const boardMember2: IUser = {
  id: '047a17d7-5a91-4040-979c-c060f9502753',
  firstName: 'BM.Bianca',
  lastName: 'Rivera',
  email: 'brivera.board.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

const boardMember2Prod: IUser = {
  ...boardMember2,
  id: '7c56f56f-5c53-4392-9310-be7472cfcb9e'
};

const boardMember2PreProd: IUser = {
  ...boardMember2,
  id: 'dc648d8f-3885-4eb1-9573-e964bb5c27c6'
};

const boardMember3: IUser = {
  id: 'ac343b9b-44f8-4d78-a0ff-efa9c19fcdac',
  firstName: 'BM.Brianna',
  lastName: 'Patel',
  email: 'bpatel.board.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

const boardMember3Prod: IUser = {
  ...boardMember3,
  id: 'e303edbc-c14f-43f6-8241-77ce6b6dd49e'
};

const boardMember3PreProd: IUser = {
  ...boardMember3,
  id: 'd2de0889-b985-4b69-a15d-c19261aeabab'
};

const editor5: IUser = {
  id: 'd5373210-972e-4ab0-940e-1ef12939c923',
  firstName: 'A.Aiden',
  lastName: 'Cruz',
  email: 'aiden.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

const editor5Prod: IUser = {
  ...editor5,
  id: '4be14459-e14b-4f8b-8e40-cd2c3e2c5ae9'
};

const editor6: IUser = {
  id: '723b7b5a-3393-4c13-98f0-8edac6d2329a',
  firstName: 'C.Charlotte',
  lastName: 'Davis',
  email: 'charlotte.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};
const editor6Prod: IUser = {
  ...editor6,
  id: '4c2990b6-e926-4a7d-977a-774cd96509ef'
};

const editor7: IUser = {
  id: '847e10f4-5c5a-4eb5-bc9b-3b9b01f57dbb',
  firstName: 'S.Simon',
  lastName: 'Clarke',
  email: 'simon.morressier.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'm',
  status: 'active'
};

const editor7Prod: IUser = {
  ...editor7,
  id: '046ce2dc-bcf4-4211-9618-bd4921cb4176'
};

export const STAGING_USERS_MAP = {
  author1,
  author2,
  editor1,
  editor2,
  reviewer1,
  reviewer2,
  reviewer3,
  boardMember1,
  boardMember2,
  boardMember3,
  orgAdmin1,
  sysAdmin1,
  editor5,
  editor6,
  editor7
} as const;

export const PROD_USERS_MAP = {
  author1: author1Prod,
  author2: author2Prod,
  editor1: editor1Prod,
  editor2: editor2Prod,
  editor5: editor5Prod,
  editor6: editor6Prod,
  editor7: editor7Prod,
  reviewer2: reviewer2Prod,
  reviewer3: reviewer3Prod,
  reviewer1: reviewer1Prod,
  boardMember1: boardMember1Prod,
  boardMember2: boardMember2Prod,
  boardMember3: boardMember3Prod,
  orgAdmin1: orgAdmin1Prod,
  sysAdmin1: sysAdmin1Prod
} as const;

export const PREPROD_USERS_MAP = {
  author1: author1PreProd,
  author2: author2PreProd,
  editor1: editor1PreProd,
  editor2: editor2PreProd,
  reviewer2: reviewer2PreProd,
  reviewer3: reviewer3PreProd,
  reviewer1: reviewer1PreProd,
  boardMember1: boardMember1PreProd,
  boardMember2: boardMember2PreProd,
  boardMember3: boardMember3PreProd,
  orgAdmin1: orgAdmin1PreProd,
  sysAdmin1: sysAdmin1PreProd
} as const;
